import React from 'react';

export const AuthenticatorIcon = () => {
  return (
    <svg viewBox="0 0 300 300" className="w-full h-auto">
      <ellipse cx="150" cy="260" rx="140" ry="20" fill="#d1f4f0" opacity="0.5"></ellipse>
      <ellipse cx="150" cy="255" rx="120" ry="15" fill="#b8ede7" opacity="0.6"></ellipse>
      <ellipse cx="150" cy="250" rx="100" ry="10" fill="#9fe6dd" opacity="0.7"></ellipse>
      <rect x="170" y="80" width="80" height="140" rx="8" fill="#7a9ca5" opacity="0.8"></rect>
      <rect x="175" y="85" width="70" height="130" rx="6" fill="#8fb3bc"></rect>
      <rect x="180" y="95" width="60" height="15" rx="2" fill="#b8d4db"></rect>
      <circle cx="210" cy="135" r="25" fill="#d1e8ed" opacity="0.3"></circle>
      <path d="M 195 135 Q 210 120 225 135 Q 210 150 195 135 Z" fill="#ffffff" opacity="0.2"></path>
      <ellipse cx="210" cy="135" rx="15" ry="18" fill="#e8f4f7" opacity="0.4"></ellipse>
      <path d="M 205 140 L 210 145 L 220 130" stroke="#ffffff" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round" opacity="0.6"></path>
      <path d="M 100 100 L 180 60 L 180 200 L 100 240 Z" fill="#f59e0b" opacity="0.9"></path>
      <path d="M 100 100 L 180 60 L 180 200 L 100 240 Z" fill="url(#shieldGradient)"></path>
      <defs>
        <linearGradient id="shieldGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" style={{stopColor:"#fbbf24", stopOpacity:1}}></stop>
          <stop offset="100%" style={{stopColor:"#f59e0b", stopOpacity:1}}></stop>
        </linearGradient>
      </defs>
      <path d="M 115 140 L 130 155 L 165 120" stroke="#ffffff" strokeWidth="8" fill="none" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M 100 100 L 140 80 L 140 170 L 100 190 Z" fill="#ffffff" opacity="0.15"></path>
    </svg>
  );
};
